export const RuleTypeMap = {
    ALL: 1,
    ANY: 2,
    CUSTOMIZE: 3,
};

export const ConfigMode = {
    MANUL: '1',
    DRAG: '2',
};
